//
// Copyright (c) 2021 Astute Global, Inc.
//

// @ts-ignore
import i18next from "i18n/i18n";
import { ButtonView, clickOutsideHandler, ContextualBalloon, Plugin } from "ckeditor5";

import privilegedAreaIcon from "img/svg/privileged_area.svg";
import PrivilegedAreaView from "./ui/privilegedAreaView";

export default class PrivilegedAreaUi extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [ContextualBalloon];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "PrivilegedAreaUi";
  }

  init() {
    this._addToolbarButton();
    this.privilegedAreaView = this._createPrivilegedAreaView();

    this.balloon = this.editor.plugins.get(ContextualBalloon);
    clickOutsideHandler({
      emitter: this.privilegedAreaView,
      activator: () => this._isPrivilegedAreaViewInPanel,
      contextElements: [this.balloon.view.element],
      callback: () => this._cancelUi(),
    });
  }

  get _isPrivilegedAreaViewInPanel() {
    return this.balloon.hasView(this.privilegedAreaView);
  }

  _addPrivilegedAreaView() {
    if (this._isPrivilegedAreaViewInPanel) {
      return;
    }
    const view = this.editor.editing.view;
    const viewDocument = view.document;
    this.privilegedAreaView.disableCssTransitions();
    this.balloon.add({
      view: this.privilegedAreaView,
      position: {
        target: () => {
          return view.domConverter.viewRangeToDom(viewDocument.selection.getFirstRange());
        },
      },
    });
    if (this.balloon.visibleView == this.privilegedAreaView) {
      this.privilegedAreaView.focus();
    }
    this.privilegedAreaView.enableCssTransitions();
  }

  _addToolbarButton() {
    const editor = this.editor;
    editor.ui.componentFactory.add("privilegedArea", (locale) => {
      const command = editor.commands.get("privilegedArea");
      const button = new ButtonView(locale);
      button.set({
        isEnabled: true,
        label: i18next.t("ckeditor.privilegedArea.buttonName"),
        icon: privilegedAreaIcon,
        tooltip: true,
      });
      button.bind("isEnabled").to(command);
      this.listenTo(button, "execute", () => this._showUi());
      return button;
    });
  }

  _cancelUi() {
    this.editor.commands.get("privilegedArea").refresh();
    this._closePrivilegedAreaView();
  }

  _closePrivilegedAreaView() {
    if (this._isPrivilegedAreaViewInPanel) {
      this.balloon.remove(this.privilegedAreaView);
      this.editor.editing.view.focus();
    }
  }

  _createPrivilegedAreaView() {
    const editor = this.editor;
    const command = editor.commands.get("privilegedArea");
    const privilegedAreaView = new PrivilegedAreaView(editor, command);
    privilegedAreaView.on("submit", () => {
      // Do not call with any arguments, all the appropriate values already 'bound' to the command
      editor.execute("privilegedArea");
      this._closePrivilegedAreaView();
    });
    privilegedAreaView.on("cancel", () => {
      this._cancelUi();
    });
    return privilegedAreaView;
  }

  _showUi() {
    this._addPrivilegedAreaView();
    this.balloon.showStack("main");
  }
}
